import { render, staticRenderFns } from "./wtMapAsset.component.vue?vue&type=template&id=244da0f6&"
import script from "./wtMapAsset.component.vue?vue&type=script&lang=js&"
export * from "./wtMapAsset.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports